<template>
  <div id="nPrintingPageTable" class="print-list_box">
    <div class="yto-box yto-box-pb">
      <el-form :inline="true" :model="form" ref="ruleForm">
        <div class="y-f y-f-a">
            <el-form-item label="分享平台" prop="platformCode" label-width="60px">
              <el-select :popper-append-to-body="false" class="y-w-200" v-model="form.platformCode" clearable
                placeholder="请选择">
                <el-option v-for="item in platformCodeList" :label="item.platformName" :value="item.platformCode" :disabled="item.disabled"
                  :key="item.platformCode"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item style="float: right">
              <el-button icon="el-icon-search" type="primary" @click="getSettingInfo(1)">查询</el-button>
              <el-button class="border-btn" type="button" @click="resetForm('ruleForm')">
                <i class="el-icon-refresh-left y-fc-4C84FF"></i>重置
              </el-button>
            </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="yto-table yto-ks-box ksNewOrderTable" style="padding:8px 10px;">
      <div class="y-mb-8">
        <el-button type="primary" @click="openAuthRealNameDialogFn">新增二维码与链接</el-button>
      </div>
      <div class="infinite-list-wrapper newCustomPrintTable " style="overflow:auto;">
        <el-table ref="customOrderTable" v-loading="loading" v-if="tableHeight" :data="tbody" :height="tableHeight">
          <el-table-column prop="qrUrl" label="二维码" :min-width="80">
            <template slot-scope="scope">
              <vue-qr :data-qr-id="scope.row.id" :ref="'imgRef' + scope.row.id" class="custom-qr" :logo-src="logoSrc"
                :text="scope.row.qrUrl" :size="64" :margin="0" :logoMargin="4" />
              <div>
                <el-button type="text" size="mini" @click="copyQRImage(scope.row.qrUrl)">复制</el-button>
                <el-button type="text" size="mini" @click="downloadQRCode(scope.row.qrUrl)">下载</el-button>
              </div>
            </template>

          </el-table-column>
          <el-table-column prop="qrUrl" label="链接" :min-width="90">
            <template slot-scope="scope">
              <div>-</div>
              <!-- 微信展示- 其他平台可以放开，当时只有微信平台后端还未提供接口 -->
              <div class="y-t-ac" v-if="false">
                <el-button type="text" size="mini" @click="copyUtrl(scope.row.qrUrl)">复制链接</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pickupOrderNo" label="分享平台" :min-width="90">
            <template slot-scope="scope">
              <div>{{ '微信'||scope.row.pickupOrderNo }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="pickupOrderNo" label="退货收件地址" :min-width="90">
            <template slot-scope="scope">
              <div>{{ scope.row.newAddressInfo ? scope.row.newAddressInfo.provinceName : '' }}
                {{ scope.row.newAddressInfo ? scope.row.newAddressInfo.cityName : '' }}
                {{ scope.row.newAddressInfo ? scope.row.newAddressInfo.districtName : '' }}
                {{ scope.row.newAddressInfo ? scope.row.newAddressInfo.address : '' }}
              </div>
              <div>{{ scope.row.newAddressInfo ? scope.row.newAddressInfo.name : '' }}
                {{
                  scope.row.newAddressInfo ? scope.row.newAddressInfo.mobile ? scope.row.newAddressInfo.mobile : scope.row.newAddressInfo.phone:''
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pickupOrderNo" label="寄件付费设置" :min-width="90">
            <template slot-scope="scope">
              <!--brokerage返佣   buyerPaysShipping买家支付运费 -->
              <div v-if=" scope.row.brokerage">加价返佣 ：每单加{{ scope.row.brokerage }} 元</div>
              <div v-if=" scope.row.buyerPaysShipping">寄件人付运费 ： 全额运费</div>
            </template>
          </el-table-column>
          <el-table-column prop="pickupOrderNo" label="其他设置" :min-width="90">
            <template slot-scope="scope">
              <!-- 自动通过审核 autoAudit  取件日期 pickUpDateRule  originalOrder-->
              <div v-if=" scope.row.autoAudit">自动通过审核：{{ scope.row.autoAudit==1 ?'开':'关'}}</div>
              <div v-if=" scope.row.pickUpDateRule">取件日期 ：{{ scope.row.pickUpDateRule=='2'?'定时取': scope.row.pickUpDateRule=='0'?'当日取':'未设置'}}</div>
              <div v-if=" scope.row.originalOrder">是否必填原单号：{{ scope.row.originalOrder=='1' ?'是':scope.row.originalOrder=='0'?'否':''}}</div>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <span class="systemColor y-c-p" @click="modifyFn(scope.row)">修改</span>
              <el-divider direction="vertical"></el-divider>
              <span class="red-txt y-c-p" @click="cancelFn(scope.row)">作废</span>
              <el-divider direction="vertical"></el-divider>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 邀请自助下单弹层 -->
    <inviteSetting v-if="showInviteSettingDialog" :isShow="showInviteSettingDialog" ref="inviteSetting" :rowInfo="rowInfo" :isEdit="isEdit"
      @closeDialog="closeInviteSettingDialog" @refreshTable="refreshTable" @openSaveAccount="openSaveAccount"  @openPreAilDialog="openPreAilDialog" @goToRealName="goToRealName">
    </inviteSetting>
  </div>
</template>

<script>
import util from '@/utils/util';
import { searchReturnPlaceOrderConfigApi, deletePlaceOrderQrApi } from '@/api/waybillPrint/returnPickupPrint'
import html2canvas from "html2canvas";
import QRCode from 'qrcode'

import { dateFormat, copyText, getShortcutsMap, YTOSHORTCUTS } from '@/utils/util';
import { PLATFORMNAMEMAP } from '@/utils/globalConfig';
export default {
  name: 'printingTable',
  components: {
    html2canvas,
    inviteSetting: () => import('./inviteSettingDialogNew'),
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },
  props: ['curComponent'],
  data() {
    return {
      logoSrc: '',
      showInviteSettingDialog: false,
      platformCodeList: [
        { platformCode: '', platformName: '全部',disabled:false },
        { platformCode: 'WEIXIN', platformName: '微信',disabled:false },
        // { platformCode: 'TAOBAO', platformName: '淘宝',disabled:false },
        // { platformCode: 'LUBAN', platformName: '抖音' ,disabled:false },
      ],

      PLATFORMNAMEMAP,
      curShortcutName: '',
      pickerOptions1: YTOSHORTCUTS,
      form: {
        platformCode: '', // 1 下单时间 2打印订单时间
      },
      loading: false,
      tbody: [],
      screenW: null,
      screenH: null,
      tableHeight: 0,
      currentRow: {},
      modifyDialog: false,
      rowInfo: {},
      isEdit: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.logoSrc = require('@/assets/images/icon/Logo_YTO@2x.png');
  },
  methods: {
    goToRealName(){
      this.$emit('goToRealName')
    },
    UpDateAlyName(username){
      this.$refs.inviteSetting.UpDateAlyName(username)
    },
    openPreAilDialog(realNameId){
      this.$emit('openPreAilDialog',realNameId)
    },
    openSaveAccount(realNameId){
      this.$emit('openSaveAccount',realNameId)
    },
    refreshTable(){
      this.init();
      this.showInviteSettingDialog = false;
    },
    // 修改订单
    modifyFn(row) {
      this.rowInfo = JSON.parse(JSON.stringify(row));
      this.isEdit = true;
      this.showInviteSettingDialog = true;     
      // F5刷新页面后，编辑弹层打开后数据不回显，因为下面时间延时还不够，刷新后加载时间较长，不能用如下文案
      // setTimeout(() => {
      //   this.$refs.inviteSetting.getAddressList(row);
      // }, 100);
    },
    deletePlaceOrderQrFn(row){
      deletePlaceOrderQrApi({id:row.id}).then(res=>{
        if(res.message=='ok'&&!res.error){
          this.$message.success('作废成功')
          this.init();
        }else{
          this.$message.error(res.error)
        }
      })
    },
    // 作废二维码
    cancelFn(row) {
      this.$confirm('作废后该二维码与链接将失效，请确认', '', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: true,
        closeOnClickModal: false
      }).then(() => {
        this.deletePlaceOrderQrFn(row)
       }).catch(() => {
        
      });
    },    
    copyUtrl(url) {
      copyText(url, '复制成功');
    },
    async downloadQRCode(url, type) {

      try {
        // 使用 qrcode 库直接生成二维码
        const qrCanvas = document.createElement('canvas');
        await QRCode.toCanvas(qrCanvas, url, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        });
        // 步骤2: 创建新的 canvas 来合并二维码和 logo
        const finalCanvas = document.createElement('canvas');
        const ctx = finalCanvas.getContext('2d');

        // 设置最终 canvas 尺寸
        finalCanvas.width = 200;
        finalCanvas.height = 200;

        // 绘制二维码
        ctx.drawImage(qrCanvas, 0, 0, 200, 200);

        // 步骤3: 加载 logo 图片
        const logoImg = new Image();
        logoImg.crossOrigin = 'anonymous'; // 处理跨域问题
        logoImg.src = this.logoSrc;

        // 等待 logo 加载完成
        logoImg.onload = () => {
          // 计算 logo 位置（居中）
          const logoSize = 40; // logo 大小
          const x = (finalCanvas.width - logoSize) / 2;
          const y = (finalCanvas.height - logoSize) / 2;

          // 绘制白色背景（可选，确保 logo 清晰可见）
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(x - 2, y - 2, logoSize + 4, logoSize + 4);

          // 绘制 logo
          ctx.drawImage(logoImg, x, y, logoSize, logoSize);
          if(type=='copy'){
            finalCanvas.toBlob(async (blob) => {
              try {
                // 使用Clipboard API复制图片
                const item = new ClipboardItem({ 'image/png': blob });
                await navigator.clipboard.write([item]);
                this.$message.success('二维码图片已复制到剪贴板', 'success');
              } catch (err) {
                console.error('复制失败:', err);
                this.$message.error('复制失败，请尝试其他方法', 'error');
              }
            });            
            return;
          } 
          // 下载最终图像
          const dataURL = finalCanvas.toDataURL('image/png');
         
          const link = document.createElement('a');
          link.download = '退货下单二维码.png';
          link.href = dataURL;
          link.click();
        };

        logoImg.onerror = (error) => {
          console.error('加载 logo 失败:', error);
          // 如果 logo 加载失败，仍然下载只有二维码的图片
          const dataURL = qrCanvas.toDataURL('image/png');
          if(type=='copy'){
            this.copyUtrl(dataURL,'复制成功');
            return;
          }            
          const link = document.createElement('a');
          link.download = '退货下单二维码.png';
          link.href = dataURL;
          link.click();
        };

      } catch (error) {
        console.error('下载二维码出错:', error);
        this.$message.error('下载二维码失败');
      }



    },
    copyQRImage(url) {
      this.downloadQRCode(url,'copy');
    },
    // 查询配置信息
    getSettingInfo() {
      // 查询配置信息
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      searchReturnPlaceOrderConfigApi({}).then(res => {
        if (res.status == 200 && res.data && res.data.length) {
          let data = res.data;
          data.forEach(item => {
            if (item.addressInfo && typeof item.addressInfo == 'string' && item.addressInfo.trim() != '') {
              let addressInfo = JSON.parse(item.addressInfo);
              this.$set(item, 'newAddressInfo', addressInfo);
            }
          })
          this.tbody = data
        } else {
          if(res.status != 200){
            this.$message.error(res.message);
          }
          this.tbody = [];
         
        }
      }).catch(err => {
        this.tbody = [];
        this.$message.error(err);
      }).finally(() => {
        loadingMask.close();
      });
    },
    openAuthRealNameDialogFn() {
      this.rowInfo = {};
      this.isEdit = false;
      this.showInviteSettingDialog = true;
    },
    closeInviteSettingDialog() {
      this.isEdit = false;
      this.showInviteSettingDialog = false;
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName] && this.$refs[formName].resetFields();
      this.$nextTick(() => {
        this.getSettingInfo(1);
      })
    },
    // 页面初始化
    async init() {
      // 获取当前分辩率宽度
      this.screenW = window.screen.width || document.body.clientWidth;
      // 获取当前分辨率高度
      this.screenH = document.documentElement.clientHeight; // 页面整体的高度
      this.tableHeight = this.screenH - 300;
      // 查询打印列表
      this.getSettingInfo();
    },



    closeModifyDialog(refresh) {
      this.modifyDialog = false;
      this.currentRow = {};
      if (refresh == 'refresh') {
        this.getOrders();
      }
    },


    // 解密收寄件人信息详情
    decryptAddressInfo(row, index, type) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      });
      decryptUserInfoApi({ ...row, decryptType: type == 'sender' ? '1' : '2' }).then(res => {
        loadingMask.close();
        if (res.success && res.data) {
          this.setRowInfoFn(row, index, type, res.data);
        } else {
          this.setRowInfoFn(row, index, type, {});
          this.$message.error(res.message || '解密失败');
        }
      }).catch((err) => {
        loadingMask.close();
        this.setRowInfoFn(row, index, type, {});
        this.$message.error(res.message || '解密失败');
      })
    },
    // 设置行信息
    setRowInfoFn(row, index, type, data) {
      if (type == 'sender') {
        this.$set(this.tbody[index], 'decryptSendName', data.sendName || ''); // 加密手机号
        this.$set(this.tbody[index], 'decryptSendMobile', data.sendMobile || ''); // 加密手机号
        this.$set(this.tbody[index], 'decryptSendPhone', data.sendPhone || ''); // 加密电话
        this.$set(this.tbody[index], 'decryptSendAddress', data.sendAddress || ''); // 加密详细地址
        this.$set(this.tbody[index], 'viewSenderAddress', !row.viewSenderAddress);
      } else {
        this.$set(this.tbody[index], 'decryptReceiveName', data.receiveName || ''); // 加密手机号
        this.$set(this.tbody[index], 'decryptReceiveMobile', data.receiveMobile || ''); // 加密手机号
        this.$set(this.tbody[index], 'decryptReceivePhone', data.receivePhone || ''); // 加密电话
        this.$set(this.tbody[index], 'decryptReceiveAddress', data.receiveAddress || ''); // 加密详细地址
        this.$set(this.tbody[index], 'viewReciverAddress', !row.viewReciverAddress);
      }
      this.tbody = [...this.tbody];
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables";

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.textarea-style {
  /deep/ .el-form-item__content {
    width: 380px;
  }

  .el-textarea {
    width: 380px;
  }
}

#nPrintingPageTable {

  /deep/ .el-popover__reference-wrapper {
    display: flex;
    align-items: center;
  }

  background-color: #e4e7ed;

  .el-table .cell.filter-sytle {
    position: relative;

    .showFilterDilaog {
      position: absolute;
    }
  }

  .el-table .cell {
    .custom-table-list-svg {
      vertical-align: middle;
    }

    .system-red-color {
      color: $red;
    }

    .elli {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .linkColor {
      color: $blue-style;
      cursor: pointer;
    }

    .grayColor {
      color: #999;
    }
  }

  .el-radio-group {
    .el-radio {
      height: 32px;
      line-height: 32px;
    }
  }
}

.el-dialog.ninvoiceDialog .el-select .el-input--suffix {
  width: 320px;
}

.el-icon-document-copy {
  margin-left: 5px;
  font-size: 10px;
  color: $blue-style;
  cursor: pointer;
}
.red-txt{
  color: #FF4D4F;
}
.y-mb-8 {
  margin-bottom: 8px;
}
</style>
